import React, { useEffect, useState } from 'react';
import { Download, RotateCw, ZoomIn, ZoomOut } from 'lucide-react';
import { Button } from '../../Button';
import { Modal } from '../../common/Modal';
import { toBn } from '../../../utils/bn';
export interface PreviewDoc {
  name: string;
  src: string;
  meta?: {
    label: string;
    value: string;
  }[];
}
interface Props {
  doc: PreviewDoc | null;
  onClose: () => void;
  actions?: React.ReactNode;
}
export function DocumentPreviewModal({
  doc,
  onClose,
  actions
}: Props) {
  const [zoom, setZoom] = useState(1);
  const [rotate, setRotate] = useState(0);
  useEffect(() => {
    setZoom(1);
    setRotate(0);
  }, [doc?.name]);
  return <Modal open={Boolean(doc)} onClose={onClose} title={doc ? `ডকুমেন্ট প্রিভিউ — ${doc.name}` : ''} width="max-w-4xl" footer={actions} data-id="element-320" data-mp="33376yzo9vkw4">
      {doc && <div className="grid gap-4 md:grid-cols-[1fr_220px]" data-id="element-321" data-mp="2afl2lp780c87">
          <div data-id="element-322" data-mp="2fexni4ej7985">
            <div className="mb-2 flex flex-wrap items-center gap-1.5" data-id="element-323" data-mp="2fenz2l94xa4k">
              <Button variant="outline" size="sm" onClick={() => setZoom(z => Math.max(0.5, z - 0.25))} aria-label="ছোট করুন" data-id="element-324" data-mp="2idbb2gjhv413"><ZoomOut className="h-4 w-4" data-id="element-325" data-mp="2ebg0elfobean" /></Button>
              <span className="w-14 text-center text-xs font-semibold text-slate-600" data-id="element-326" data-mp="2ee2hpcsd9862">{toBn(Math.round(zoom * 100))}%</span>
              <Button variant="outline" size="sm" onClick={() => setZoom(z => Math.min(3, z + 0.25))} aria-label="বড় করুন" data-id="element-327" data-mp="24m656wpj9fib"><ZoomIn className="h-4 w-4" data-id="element-328" data-mp="1zmtneqdiqyml" /></Button>
              <Button variant="outline" size="sm" onClick={() => setRotate(r => (r + 90) % 360)} data-id="element-329" data-mp="1zod24cjj11m9"><RotateCw className="h-4 w-4" data-id="element-330" data-mp="1un79sfts3gd9" />ঘোরান</Button>
              <a href={doc.src} download target="_blank" rel="noreferrer" className="ml-auto inline-flex h-8 items-center gap-1.5 rounded-md border border-input px-3 text-sm font-medium text-navy-800 hover:bg-slate-50" data-id="element-331" data-mp="1qm3q1i8m106r">
                <Download className="h-4 w-4" data-id="element-332" data-mp="3l0o61hlzk7jt" />ডাউনলোড
              </a>
            </div>
            <div className="flex h-[420px] items-center justify-center overflow-auto rounded-md border border-border bg-slate-800" data-id="element-333" data-mp="3g0s19g5gsc37">
              <img src={doc.src} alt={doc.name} style={{
            transform: `scale(${zoom}) rotate(${rotate}deg)`
          }} className="max-h-[400px] max-w-full object-contain transition-transform duration-200" data-id="element-334" data-mp="2yzgkj7xnftd" />
            </div>
          </div>
          <dl className="space-y-2.5 rounded-md bg-slate-50 p-3 text-sm" data-id="element-335" data-mp="3v4l4qwhn34an">
            {(doc.meta ?? []).map(m => <div key={m.label} data-id="element-336" data-mp="mmp0k49mobs1">
                <dt className="text-xs text-slate-500" data-id="element-337" data-mp="qqmwk63np6gv">{m.label}</dt>
                <dd className="break-words font-medium text-navy-900" data-id="element-338" data-mp="qnsc4ekn7lng">{m.value}</dd>
              </div>)}
            <p className="border-t border-slate-200 pt-2 text-[11px] text-slate-400" data-id="element-339" data-mp="hp6ow6487igc">মালিক কর্তৃক মোবাইল অ্যাপে আপলোডকৃত ফাইল (নমুনা)</p>
          </dl>
        </div>}
    </Modal>;
}